module.exports = __webpack_public_path__ + "img/level.dc34b538.svg";